import React from 'react';
import accessibleSvg from 'utils/accessibleSvg';

export default accessibleSvg(({ children, ...props }) => (
  <svg fill="currentColor" viewBox="0 0 512 384" {...props}>
    {children}
    <path d="M464 384H48c-26.51 0-48-21.49-48-48V48C0 21.49 21.49 0 48 0h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 56c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 320h384V208l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 256l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 272z" />
  </svg>
));
